<script setup>
import { useGroupData } from '@daysmart/daysmart-vue-components/composables'

const props = defineProps({
  events: Object,
  date: String,
  closedDates: {
    type: Array,
    default: () => [],
  },
})
const { t, d } = useI18n()

const { params, groupedData: groupedEvents } = useGroupData()
params.getGroupKey = event => event.starts_at.slice(0, 19)

const sortedGroupedEvents = computed(() =>
  groupedEvents.value.slice().sort((a, b) =>
    new Date(a.key) < new Date(b.key) ? -1 : 1,
  ),
)

watch(
  () => props.events,
  value => params.data = value,
  {
    immediate: true,
    deep: true,
  },
)
</script>

<template>
  <div class="schedule-day-view">
    <div class="flex flex-col rounded-2 ring-1 ring-surface-600">
      <ScheduleClosedSign v-if="closedDates.includes(date)" />
      <template
        v-for="group in sortedGroupedEvents"
        :key="group.key"
      >
        <time
          class="border-b-1 border-t-1 border-surface-600 bg-surface-300 px-5 py-2 text-left text-text-600 font-700"
          :datetime="group.key"
        >
          {{ d(group.key, 'time').toLowerCase() }}
        </time>
        <ScheduleEventItemContainer>
          <ScheduleEventItem
            v-for="(event, eventIndex) in group.data"
            :key="group.key + eventIndex"
            :event="event"
          />
        </ScheduleEventItemContainer>
      </template>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.schedule-day-view {
  :deep(.calendar-event-container) {
    @apply p-0 flex-gap-0;

    &:first-child {
      @apply rounded-t-2;
      .caption {
        @apply rounded-t-2 border-t-0;
      }

      .schedule-event-item-header {
        @apply border-t-0 rounded-t-2;
      }
    }

    &:last-child {
      @apply rounded-b-2;
    }
  }
}
</style>
